<script setup>
import gsap, { Expo, TimelineMax } from 'gsap'

const props = defineProps({ value: Number, index: String, potentialId: String })
setTimeout(() => {
  const game = { score: 0 }

  function updateHandler () {
    const element = document.getElementById(`b2c-quick-view--score-${props.index}`)
    if (element) {
      element.innerHTML = `+${game.score}`
    }
  }
  gsap.to(`#b2c-quick-view-chart--score-container-${props.index}`, { opacity: 1, duration: 3 })
  const tl = new TimelineMax({ repeatDelay: 0, delay: 0 })
  tl.to(game, {
    duration: 3.6,
    score: props.value,
    roundProps: 'score',
    onUpdate: updateHandler,
    ease: Expo.easeNone
  }, 2)
  tl.to(`#b2c-quick-view-inner-line-${props.index}`, {
    'stroke-dasharray': `+${300 * (props.value / 100)}`,
    duration: 3.6,
    ease: Expo.easeNone
  }, 2)
}, 300)
</script>

<template lang="pug">
.b2c-quick-view-chart--container
  .blur
  .pie-holder
    svg(width='150' height='140' viewBox='0 0 143 126' fill='none' xmlns='http://www.w3.org/2000/svg')
      path(d='M28.2259 118C15.7822 106.404 8 89.8694 8 71.5162C8 36.4372 36.4299 8 71.5 8C106.57 8 135 36.4372 135 71.5162C135 89.8694 127.218 106.404 114.774 118' stroke='#DCE7F2' stroke-width='15' stroke-linecap='round')
      path(:id="`b2c-quick-view-inner-line-${index}`" d='M28.2259 118C15.7822 106.404 8 89.8694 8 71.5162C8 36.4372 36.4299 8 71.5 8C106.57 8 135 36.4372 135 71.5162C135 89.8694 127.218 106.404 114.774 118' stroke='#007BFF' stroke-width='13' stroke-linecap='round' style='stroke-dasharray: 4, 300; stroke-dashoffset: 0;"')
    .b2c-quick-view-chart--score-container(:id="`b2c-quick-view-chart--score-container-${index}`")
      .b2c-quick-view-chart--score(:id="`b2c-quick-view--score-${index}`") 0
      .b2c-quick-view-chart--score-subtitle PROZENT
</template>

<style lang="sass" scoped>
.blur
  width: calc(100% + 20px)
  height: calc(100% + 20px)
  position: absolute
  top: -10px
  left: -10px
  backdrop-filter: blur(12px)
  z-index: 1
.b2c-quick-view-chart--container
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  position: relative
  .pie-holder
    margin: 0 auto 0 auto
    overflow: hidden
    display: flex
    align-items: center
    justify-content: center
    width: 190px
    height: 150px
    position: relative

    .b2c-quick-view-chart--score-container
      opacity: 0
      position: absolute
      top: 45px
      width: 100%
      display: flex
      flex-direction: column
      align-items: center
      .b2c-quick-view-chart--score-subtitle
        font-weight: 500
        font-size: 14px
        line-height: 16px
        color: #007BFF
      .b2c-quick-view-chart--score
        font-weight: 700
        font-size: 45px
        line-height: 50px
        color: #007BFF
</style>
